
import React from "react";
import { motion } from "framer-motion";
import { Tag } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PromoBar = () => {
  return (
    <motion.div
      className="relative z-10 bg-gradient-to-r from-madts-pink to-madts-purple text-white py-3 px-4 mx-4 md:mx-8 mt-4 rounded-lg shadow-lg"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="flex items-center mb-2 md:mb-0">
          <Tag className="h-5 w-5 mr-2 animate-pulse" />
          <p className="font-medium">
            <span className="font-bold">SPECIAL OFFER:</span> Buy 3 T-Shirts, Get the 4th Free!
          </p>
        </div>
        <Button 
          size="sm" 
          className="bg-white text-madts-purple hover:bg-white/90"
          asChild
        >
          <Link to="/book">Book Now</Link>
        </Button>
      </div>
    </motion.div>
  );
};

export default PromoBar;
